module.exports = __webpack_public_path__ + "static/media/a14_lighting.27871c15.png";